import { motion } from 'framer-motion';

const TerminiCondizioni = () => {
  return (
    <div className="min-h-screen py-24 px-6 md:px-12 lg:px-24" data-testid="termini-page">
      <div className="max-w-4xl mx-auto">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
        >
          <h1 className="font-serif text-4xl md:text-5xl mb-8">Termini e Condizioni d'Uso</h1>
          
          <div className="space-y-6 text-foreground/80 leading-relaxed">
            <p className="text-sm text-foreground/60">Ultimo aggiornamento: {new Date().toLocaleDateString('it-IT')}</p>
            
            <section>
              <h2 className="font-serif text-2xl font-semibold text-foreground mb-4">1. Informazioni Generali</h2>
              <p>
                Il presente sito web è gestito da <strong>Nancy Ghislotti</strong>, P.IVA 04569820162.<br/>
                L'accesso e l'utilizzo del sito sono soggetti ai seguenti Termini e Condizioni d'Uso 
                e alla normativa vigente. Utilizzando il sito, l'utente accetta integralmente questi termini.
              </p>
            </section>

            <section>
              <h2 className="font-serif text-2xl font-semibold text-foreground mb-4">2. Oggetto del Sito</h2>
              <p>
                Questo sito ha finalità informative e divulgative nel settore dei viaggi in famiglia. 
                I contenuti pubblicati (articoli, fotografie, video) sono di proprietà esclusiva di 
                Nancy Ghislotti e protetti dalle leggi sul diritto d'autore.
              </p>
            </section>

            <section>
              <h2 className="font-serif text-2xl font-semibold text-foreground mb-4">3. Diritti di Proprietà Intellettuale</h2>
              <p>
                Tutti i contenuti presenti sul sito (testi, immagini, loghi, grafica, video) sono protetti 
                da diritto d'autore e altri diritti di proprietà intellettuale. È vietata la riproduzione, 
                distribuzione, trasmissione, modifica o pubblicazione dei contenuti senza autorizzazione scritta.
              </p>
              <p className="mt-2">
                È consentita la condivisione dei contenuti tramite i pulsanti social presenti sul sito, 
                citando sempre la fonte.
              </p>
            </section>

            <section>
              <h2 className="font-serif text-2xl font-semibold text-foreground mb-4">4. Utilizzo del Sito</h2>
              <p>L'utente si impegna a utilizzare il sito in modo conforme alla legge e a questi Termini. È vietato:</p>
              <ul className="list-disc pl-6 mt-2 space-y-2">
                <li>Utilizzare il sito per scopi illeciti o non autorizzati</li>
                <li>Violare diritti di proprietà intellettuale</li>
                <li>Trasmettere virus, malware o codice dannoso</li>
                <li>Tentare di accedere in modo non autorizzato a sistemi o dati</li>
                <li>Utilizzare bot, spider o altri strumenti automatizzati senza autorizzazione</li>
              </ul>
            </section>

            <section>
              <h2 className="font-serif text-2xl font-semibold text-foreground mb-4">5. Contenuti Generati dagli Utenti</h2>
              <p>
                Eventuali commenti o contenuti inviati dagli utenti tramite form di contatto diventano 
                di proprietà del sito. Nancy Ghislotti si riserva il diritto di moderare, modificare 
                o rimuovere contenuti inappropriati, offensivi o che violano i diritti di terzi.
              </p>
            </section>

            <section>
              <h2 className="font-serif text-2xl font-semibold text-foreground mb-4">6. Collegamenti Esterni</h2>
              <p>
                Il sito può contenere link a siti web di terze parti. Nancy Ghislotti non è responsabile 
                per il contenuto, le politiche sulla privacy o le pratiche di siti esterni. L'accesso 
                a tali siti avviene a rischio e responsabilità dell'utente.
              </p>
            </section>

            <section>
              <h2 className="font-serif text-2xl font-semibold text-foreground mb-4">7. Disclaimer e Limitazioni di Responsabilità</h2>
              <p>
                I contenuti del sito sono forniti "così come sono" a scopo puramente informativo. 
                Nancy Ghislotti non garantisce l'accuratezza, la completezza o l'aggiornamento delle informazioni.
              </p>
              <p className="mt-2">
                Nancy Ghislotti non è responsabile per eventuali danni diretti o indiretti derivanti 
                dall'utilizzo del sito o dall'impossibilità di accedervi.
              </p>
            </section>

            <section>
              <h2 className="font-serif text-2xl font-semibold text-foreground mb-4">8. Collaborazioni e Contenuti Sponsorizzati</h2>
              <p>
                Alcuni contenuti possono essere realizzati in collaborazione con brand o aziende. 
                Ogni collaborazione commerciale sarà chiaramente indicata e dichiarata nel rispetto 
                della trasparenza verso i lettori e della normativa vigente.
              </p>
            </section>

            <section>
              <h2 className="font-serif text-2xl font-semibold text-foreground mb-4">9. Modifiche ai Termini e Condizioni</h2>
              <p>
                Nancy Ghislotti si riserva il diritto di modificare questi Termini e Condizioni in qualsiasi 
                momento. Le modifiche saranno efficaci dalla data di pubblicazione sul sito. L'uso continuato 
                del sito dopo le modifiche costituisce accettazione dei nuovi termini.
              </p>
            </section>

            <section>
              <h2 className="font-serif text-2xl font-semibold text-foreground mb-4">10. Legge Applicabile e Foro Competente</h2>
              <p>
                Questi Termini e Condizioni sono regolati dalla legge italiana. Per qualsiasi controversia 
                sarà competente in via esclusiva il Foro di Milano.
              </p>
            </section>

            <section>
              <h2 className="font-serif text-2xl font-semibold text-foreground mb-4">11. Contatti</h2>
              <p>
                Per qualsiasi domanda riguardante questi Termini e Condizioni, puoi contattarci all'indirizzo:<br/>
                <strong>info@chichiinviaggio.com</strong>
              </p>
            </section>
          </div>
        </motion.div>
      </div>
    </div>
  );
};

export default TerminiCondizioni;